import {
	// eslint-disable-next-line jira/import/no-restricted-import
	ISSUE_ASSIGNED_EVENT,
	// eslint-disable-next-line jira/import/no-restricted-import
	ISSUE_CREATED_EVENT,
	// eslint-disable-next-line jira/import/no-restricted-import
	ISSUE_DELETED_EVENT,
	// eslint-disable-next-line jira/import/no-restricted-import
	ISSUE_TRANSITIONED_EVENT,
	// eslint-disable-next-line jira/import/no-restricted-import
	ISSUE_UPDATED_EVENT,
	// eslint-disable-next-line jira/import/no-restricted-import
	ISSUE_PARENT_ASSOCIATION_EVENT,
} from '@atlassian/jira-realtime/src/common/constants/events.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import type { RealtimeEventType } from '@atlassian/jira-realtime/src/common/types/events.tsx';

export const APP_ID = 'software.backlog-panel';

export const DIVIDER_DRAGGABLE_ID_PREFIX = 'DIVIDER_DRAGGABLE_ID';
export const ANALYTICS_SOURCE_EPIC_PANEL = 'epic panel';
export const EXPERIENCE_TRACKER_PROVIDER_SOURCE = 'epicPanel';

export const EPIC_PANEL_VIEW_EXPERIENCE = 'viewEpicPanel';
export const EPIC_PANEL_INLINE_ISSUE_CREATE_EXPERIENCE = 'createInlineIssueEpicPanel';
export const EPIC_PANEL_GLOBAL_ISSUE_CREATE_EXPERIENCE = 'createGlobalIssueEpicPanel';
// TODO: unify as part of `jira-epic-panel-unify-epic-mutations`
export const EPIC_PANEL_ASSIGN_EXPERIENCE = 'assignEpicPanel';
export const EPIC_PANEL_UNASSIGN_EXPERIENCE = 'unassignEpicPanel';
export const EPIC_PANEL_RANK_EXPERIENCE = 'rankCardEpicPanel';

export const ABORT_EXPERIENCE_MISSING_REQUIRED_FIELD_REASON = 'require-field-missing';
export const ABORT_EXPERIENCE_CANCELED_BY_USE_REASON = 'global-issue-create-canceled-by-user';

export const EPIC_PREFIX = 'EPIC-';
export const VERSION_PREFIX = 'VERSION-';

export const DEFAULT_PARENT_ISSUE_TYPE_NAME = 'Epic';
export const UNASSIGNED_EPIC_ID = 0;
export const UNASSIGNED_EPIC_ISSUE_KEY = 'ISK-0';

export const REALTIME_EVENTS: RealtimeEventType[] = [
	ISSUE_ASSIGNED_EVENT,
	ISSUE_CREATED_EVENT,
	ISSUE_DELETED_EVENT,
	ISSUE_TRANSITIONED_EVENT,
	ISSUE_UPDATED_EVENT,
	ISSUE_PARENT_ASSOCIATION_EVENT,
];

// TODO: unify as part of `jira-epic-panel-unify-epic-mutations`
export const DND_OPERATION_CARD_PARENT_SET = 'cardParentSet';
export const DND_OPERATION_CARD_PARENT_UNSET = 'cardParentUnset';
export const DND_OPERATION_EPIC_RANK_UPDATE = 'epicRankUpdate';

export const EPIC_CARD_DESCRIPTION_ID = 'epicCardDescriptionId';

// Backlog card list stops fitting inside the viewport at this width
// with both version & epic panels open, no issue open, and sidebar uncollapsed.
export const COMPACT_BREAKPOINT = 1510;

export const PAGE_SIZE = 100;
